import styled from 'styled-components'

export const TablePaymentLinks = styled.table`
    padding: 10px;
    table-layout: fixed;
    border-collapse: collapse;
    width: 100%;
    min-width: 1000px;

    /* &.my-links {
    min-width: 1280px;
  } */
    thead {
        padding: 0 10px;
        border-bottom: 1px solid #d3d3d3;
        /* border-top: 1px solid #d3d3d3; */

        th {
            color: #a8a39d;
            font-weight: 400;
            font-family: 'Poppins';
            font-size: 14px;
            padding: 10px 0;
            height: 63px;
            /* width: min-content; */
        }

        th:first-child {
            /* width: 50px; */
            padding: 0 10px;
        }
        /* 
    th.valor {
      width: 10%;
    } */

        th:last-child {
            width: 50px;
        }
    }

    tbody {
        tr:not(tr:last-child) {
            border-bottom: 1px solid #d3d3d3;
        }

        tr > td {
            color: #333;
            font-family: 'Inter';
            font-weight: 400;
            font-size: 12px;
            /* width: max-content; */
        }

        td:first-child {
            /* width: 50px; */
            padding: 0 10px;
        }
        tr {
            cursor: pointer;

            &:hover {
                background: rgba(0, 157, 221, 0.1);
            }
        }

        .link {
            display: flex;
            align-items: center;
            gap: 6px;
            color: #4c83ee;
        }
    }

    td,
    th {
        padding: 15px 0;
        text-align: left;
    }
`

export const TableApproveLinks = styled.table`
    padding: 10px;
    table-layout: fixed;
    border-collapse: collapse;
    width: 100%;
    min-width: 1000px;
    thead {
        padding: 0 10px;
        border-bottom: 1px solid #d3d3d3;
        /* border-top: 1px solid #d3d3d3; */

        th {
            color: #a8a39d;
            font-weight: 400;
            font-family: 'Poppins';
            font-size: 14px;
            padding: 10px 0;
            height: 63px;
            /* width: min-content; */
        }

        th:first-child {
            /* width: 50px; */
            padding: 0 10px;
        }
        /* 
    th.valor {
      width: 10%;
    } */

        th:last-child {
            width: 50px;
        }
    }

    tbody {
        tr:not(tr:last-child) {
            border-bottom: 1px solid #d3d3d3;
        }

        td.actions {
            form {
                display: flex;
                gap: 8px;

                .see {
                    border-radius: 8px;
                    padding: 3px 8px;
                    font-family: 'Roboto', sans-serif;
                    /* border: 1px solid #009ddd; */
                    /* background: rgba(0, 157, 221, 0.1); */

                    color: #1976d2;
                    border: 1px solid rgba(25, 118, 210, 0.5);
                    background-color: rgba(25, 118, 210, 0.12);
                    cursor: pointer;
                    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
                    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
                    box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
                        rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
                }
            }
        }

        tr > td {
            color: #333;
            font-family: 'Inter';
            font-weight: 400;
            font-size: 12px;
            /* width: max-content; */
        }

        td:first-child {
            /* width: 50px; */
            padding: 0 10px;
        }

        tr {
            cursor: pointer;

            &:hover {
                background: rgba(0, 157, 221, 0.1);
            }
        }

        .link {
            display: flex;
            align-items: center;
            gap: 6px;
        }
    }

    td,
    th {
        padding: 15px 0;
        text-align: left;
    }
`
